// 利用規約・プライバシーポリシー用
// 本番用ドメイン
/*
課題・障害番号: KOSHO-21,22
対応日: 2026/3/18
担当者: ユリヤ
修正概要: 利用規約・プライバシーポリシーが表示されない問題修正
*/
// スマートワンヘルス ルートURL
export const SMAONE_ROOT_URL = "https://smaone.jp";
/*
課題・障害番号: jira-802
対応日: 2026/04/07
担当者: ユリヤ
修正概要: 利用規約とプラポの同意チェックボックスを活性化とURL差替え
*/
// スマートワンヘルス 利用規約URL
export const SMAONE_TERMS_URL = SMAONE_ROOT_URL + "/terms/app/";

// スマートワンヘルス プライバシーポリシーURL
export const SMAONE_PRIVACY_URL = SMAONE_ROOT_URL + "/policy/privacy.html";

// スマートワンヘルス お問合せURL
export const SMAONE_CONTACT_URL = SMAONE_ROOT_URL + "/contact/app/";
/*
END
課題・障害番号: jira-802
*/
/*
END
課題・障害番号: KOSHO-21,22
*/

// アプリ情報画面用
export const APP_INFO = {
  APP_NAME: "スマワン",
  APP_COMPANY: "株式会社インテグリティ・ヘルスケア",
  COMPANY_ADDRESS: "〒104-0045\n東京都中央区築地3-12-5 +SHIFT TSUKIJI 4F",
};

//TOP画面の企業・健保の名称のタイトル表示範囲を制御する
export const TOP_SCREEN_TITLE_LETTER_COUNT_MAX = 12;

/*
課題・障害番号: IH-BUG-399
対応日: 2026/04/26
担当者: 檜垣
修正概要: オンライン診療/薬局の一覧遷移に用いるfacilityType関連の値を定数化
*/
export const FACILITY_TYPE_QUERY_KEY = "facilityType";
export const FACILITY_TYPE = {
  CLINIC: "1",
  PHARMACY: "2",
};
export const EMPLOYEE_WEB_LIST_PATH = "/EmployeeWeb/List";
export const EMPLOYEE_NATIVE_LIST_PATH = "/EmployeeNativeApp/List";
/*
END
課題・障害番号: IH-BUG-399
*/

/*
課題・障害番号: IH-BUG-542
対応日: 2026/05/21
担当者: 檜垣
修正概要: 「受診する」リンク押下時にPC（非モバイルUA）からWebTop画面（犬のマスコット＋一覧）へ遷移させるための定数を追加
*/
export const EMPLOYEE_WEB_TOP_PATH = "/EmployeeWeb";
/*
END
課題・障害番号: IH-BUG-542
*/

/*
課題・障害番号: IH-BUG-508
対応日: 2026/05/16
担当者: 檜垣
修正概要: facilityType→表示ラベルのフォールバック解決に用いる共通定数を追加。
          FACILITY_TYPEと結びつくため同ファイル直下に集約し、List画面のヘッダタイトル復元および
          他画面（タスクメッセージ等）の同種変換の再利用を可能にする
*/
export const FACILITY_TYPE_LABEL = {
  [FACILITY_TYPE.CLINIC]: "オンライン診療",
  [FACILITY_TYPE.PHARMACY]: "オンライン薬局",
};
/*
END
課題・障害番号: IH-BUG-508
*/

/*
課題・障害番号: KOSHO-476
対応日: 2026/05/08
担当者: 小林
修正概要: オンライン診療URLにURL形式以外が設定できてしまう問題を対応
*/
export const RESERVATION_URL_DISALLOWED_DOMAINS = (
  process.env.REACT_APP_RESERVATION_URL_DISALLOWED_DOMAINS ?? ""
)
  .split(",")
  .map((d) => d.trim().toLowerCase())
  .filter(Boolean);
/*
END
課題・障害番号: KOSHO-476
*/

/*
課題・障害番号: KOSHO-156
対応日: 2026/03/30
担当者: 檜垣
修正概要: タグ名表示時に最大10文字で改行するための上限値を定義
*/
export const TAG_NAME_LINE_BREAK_MAX_CHAR_COUNT = 10;
/*
END
課題・障害番号: KOSHO-156
*/

// デフォルトアイコン
export const DEFAULT_ICON_DATA_URI =
  "data:image/svg+xml;utf8," +
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24">
  <path d="M12 12.2c2.4 0 4.3-1.9 4.3-4.3S14.4 3.6 12 3.6 7.7 5.5 7.7 7.9s1.9 4.3 4.3 4.3Z"
        fill="none" stroke="#6f6f6f" stroke-width="1.6" stroke-linejoin="round"/>
  <path d="M3.9 19.4c0-3.4 3.6-6.1 8.1-6.1s8.1 2.7 8.1 6.1"
        fill="none" stroke="#6f6f6f" stroke-width="1.6" stroke-linejoin="round"/>
</svg>
`);

// 未読件数上限表示
export const MAX_BADGE_COUNT = 99;

// 健診結果サマリの機能別判定行数追加上限
export const MAX_HEALTH_CHECK_ROW_COUNT = 25;

// 健診結果詳細の機能別判定行数追加上限
export const MAX_HEALTH_CHECK_DETAILS_ROW_COUNT = 150;

/*
課題・障害番号: 品向-81
対応日: 2026/04/06
担当者: 檜垣
修正概要: CSV一括登録の上限件数を1000件で共通化
*/
export const CSV_UPLOAD_MAX_RECORDS = 1000;
/*
END
課題・障害番号: 品向-81
*/

/*
課題・障害番号: 27-KOSHO-53
対応日: 2026/05/11
担当者: 檜垣
修正概要: システム管理Webの健診CSV登録で許容するデータ行数上限を定数化
*/
export const SYSTEM_ADMIN_HEALTHCHECK_CSV_MAX_RECORDS = 1;
/*
END
課題・障害番号: 27-KOSHO-53
*/

/*
課題・障害番号: ST20-KOSHO-19
対応日: 2026/04/16
担当者: 檜垣
修正概要: 汎用マスタのリソース区分に合わせて組織・部門CSV履歴用コードと完了ステータスを定義
*/
export const CSV_UPLOAD_FILE_KIND = {
  AFFILIATIONS: "41",
  DEPARTMENTS: "42",
};

export const CSV_UPLOAD_PROCESS_STATUS = {
  COMPLETED: "3",
};
/*
END
課題・障害番号: ST20-KOSHO-19
*/

// タスク全体のステータス(tasks.task_status)
export const TASK_WHOLE_STATUS = {
  UNSENT: 0, // 配信前
  WORKING: 1, // 実施中
  COMPLETED_WITHOUT_MISS: 2, // 完了（未対応なし）
  COMPLETED_WITH_MISS: 3, // 完了（未対応あり）
};

// 個別タスクのステータス(task_users.task_status)
export const TASK_STATUS = {
  BEFORE_SEND: 0, //配信前
  UNCHECKED: 1, //未確認(配信後)
  CHECKED: 2, //対応中
  COMPLETED: 3, //完了
  INCOMPLETE: 4, //未完了
};

// タスク回答種類
export const TASK_RESPONSE_TYPE = {
  YES_NO: 0, //はい・いいえ
  DATE: 1, //日付
  ENQUETE: 2, //アンケート
};

// CSSをに挿入するための一意のID一覧
export const STYLE_ELEMENT_ID = {
  TASK_DETAIL: "mobile-task-detail-page-styles-v1",
  TASK_PROFILE: "task_profile-modal-styles-v1",
  TABLE_LIST: "mobile-table-list-styles-v1",
  APP_INFO: "mobile-app-info-list-styles-v1",
  COMMON_BUTTON: "common-button-styles-v1",
  COMMON_RADIO_BUTTON: "common-radio-button-styles-v1",
  PROFILE_SCREEN: "profile-screen-styles-v1",
  COMMON_MODAL: "common-modal-styles-v1",
  COMMON_TOAST: "common-toast-styles-v1",
  HEADER_ICON: "mobile-header-icon-styles-v1",
  CLOSE_BUTTON: "close-button-styles-v1",
};

/*
課題・障害番号: IH-BUG-282
対応日: 2026/04/08
担当者: 檜垣
修正概要: タスク対象者の従業員詳細を他タブ遷移時に閉じるためのカスタムイベント名を追加
*/
export const CUSTOM_EVENT = {
  CLOSE_TASK_TARGET_USER_SUB_DETAIL: "ih.closeTaskTargetUserSubDetail",
  /*
  課題・障害番号: IH-BUG-513
  対応日: 2026/05/21
  担当者: 小林
  修正概要: 自身の管理者情報（manage_target 含む）を更新した直後に、
            未読・閲覧スコープなどのキャッシュを再取得させるためのカスタムイベント名
  */
  ADMIN_SELF_UPDATED: "ih.adminSelfUpdated",
};
/*
END
課題・障害番号: IH-BUG-282
*/

// 共通色
export const COLORS = {
  LINK_COLOR: "#005CC7",
  TEXT_COLOR: "#000",
  TEXT_SUB_COLOR: "#444",
  TEXT_PLACEHOLDER: "#999",
  BUTTON_COLOR_POSITIVE: "#005CC7",
  BUTTON_COLOR_POSITIVE_TEXT: "#fff",
  BUTTON_COLOR_POSITIVE_HOVER: "#004AA0",
  BUTTON_COLOR_CANCEL: "#fff",
  BUTTON_COLOR_CANCEL_TEXT: "#666",
  BUTTON_COLOR_CANCEL_HOVER: "rgba(0, 92, 199, 0.04)",
  BUTTON_COLOR_NEGATIVE: "#ff4455",
  BUTTON_COLOR_NEGATIVE_TEXT: "#fff",
  BUTTON_COLOR_NEGATIVE_HOVER: "#e6394b",
  BUTTON_COLOR_DISABLE: "#CCC",
  BUTTON_COLOR_DISABLE_TEXT: "#fff",
  TABLE_COLOR: "#DAE5F8",
};

// 共通フォント
export const FONT_FAMILY = '"Noto Sans JP", sans-serif';

// ヘッダーアイコンの共通スタイル
export const HEADER_ICON_STYLES = `
  .mobile-header-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    user-select: none;
  }
  .mobile-header-icon {
    width: 28px;
    height: 28px;
    object-fit: contain;
    display: block;
    color: #005CC7;
  }
    .mobile-header-icon_disabled {
    width: 28px;
    height: 28px;
    object-fit: contain;
    display: block;
    color: #666;
  }
`;

// S3のディレクトリ
export const S3_DIRECTORY = {
  MEDICAL_EXAINATION: "medical_examination",
};

// 男女コード
export const GENDER = {
  MALE: 1,
  FEMALE: 2,
};

// 同意/不同意
export const AGREEMENT_OPTIONS = [
  { value: 1, label: "同意する" },
  { value: 0, label: "同意しない" },
];

// 共通桁数
export const TWO_DIGITS = 2;

// タイムアウト待ち時間
export const TIMEOUT = 15000;

// 確認コード
export const VERIFY_CODE = 6;
/*
課題・障害番号: KOSHO-166
対応日: 2026/04/02
担当者: 檜垣
修正概要: 登録代表者メール変更時の Cognito 検証コード入力モーダル
*/
// 認証コード再送の待機秒数
export const RESEND_INTERVAL_SECONDS = 60;
/*
END
課題・障害番号: KOSHO-166
*/

// 健診結果登録・編集画面用（ヘッダーカード用）
export const KENSHIN_HEADER_CHARACTER_LIMIT = {
  /*
  課題・障害番号: 27-KOSHO-57
  対応日: 2026/05/08
  担当者: 小林
  修正概要: 実施機関の文字数制限を修正
  */
  HOSPITAL_NAME: 50,
  /*
  END
  課題・障害番号: 27-KOSHO-57
  */
  JUDGEMENT_TEXT: 28,
  FINAL_JUDGEMENT: 10,
};

// 健診結果登録・編集画面用
export const KENSHIN_CHARACTER_LIMIT = {
  SECTION_LABEL: 15,
  CHECK_COMMENT: 33,
  RESULT: 9,
};

// 健診検査(カメラ取り込み) 画面用
export const HEALTHCHECK_CAMERA_ADD_MAX_FILE_COUNT = 20;
export const HEALTHCHECK_CAMERA_ADD_LIMIT_TOTAL_MB = 100;
// eslint-disable-next-line no-magic-numbers
export const KIBIBYTE = 1024;
export const BYTES_PER_MB = KIBIBYTE * KIBIBYTE;
export const HEALTHCHECK_CAMERA_ADD_LIMIT_TOTAL_BYTES =
  HEALTHCHECK_CAMERA_ADD_LIMIT_TOTAL_MB * BYTES_PER_MB;

// ヘルスチェックタイプ
export const HEALTHCHECK_TYPE = {
  INSPECTION: 1, //検査
  CHECKUP: 2, //健診
  SPECIFIC_CHECKUP: 3, //特定健診
};

// ヘルスチェックタイプ
export const REGIST_TYPE = {
  COMPANY_REG: 1, //企業登録
  INSURANCE_REG: 2, //健保登録
  USER_REG: 4, //本人登録
};

// 出力区分
export const EXPORT_TYPE_FILTER = {
  STANDART: 1, //標準
  ALL: 2, //すべて
  TOKUTEI: 3, //特定健診
  MONSHIN: 4, //問診
};

/*
課題・障害番号: IH-BUG-231
対応日: 2026/04/25
担当者: 檜垣
修正概要: 健診項目種別コードを共通定数化
*/
// 健診項目種別コード
/*
・1: 文字列入力項目
・2: 数値/小数入力項目
・3: コード値選択項目
・4: 日付入力項目
*/
export const HEALTH_CHECK_ITEM_KIND = {
  TEXT: "1",
  DECIMAL: "2",
  CODE: "3",
  DATE: "4",
};
/*
END
課題・障害番号: IH-BUG-231
*/

// 健診・検査結果詳細画面の編集モードで小数点以下の桁数
export const DECIMAL_DIGIT = 2;
// タスクアンケートの回答用
export const SURVEY_CHARACTER_LIMIT = {
  FREE_ANSWER: 500,
  MULTICHOICE_FREE_ANSWER: 300,
};

// アンケート設問タイプ
export const QUESTION_TYPE_CODE = {
  SINGLE_ANSWER: "1",
  MULTI_ANSWER: "2",
  FREE_ANSWER: "3",
};

// 男女選択肢
export const GENDER_CODE_OPTIONS = [
  { code: "1", name: "男性", general1: "男" },
  { code: "2", name: "女性", general1: "女" },
];

/*
  故障管理一覧表: KOSHO-70
  対応日: 2026/3/20
  担当者: 越智
  修正概要: 雇用形態は 0:社員、1:パート・アルバイト、2:その他
*/
// 雇用形態選択肢
export const EMPLOYMENT_TYPE_OPTIONS = [
  { code: "0", name: "社員" },
  { code: "1", name: "パート・アルバイト" },
  { code: "2", name: "その他" },
];
/*
  END
  故障管理一覧表: KOSHO-70
*/

/*
課題・障害番号: 旧：残課題一覧-49
対応日: 2026/03/26
担当者: 黄
修正概要: 定数を追加
*/
// health_check_kind
export const HEALTH_CHECK_KIND = [
  { code: "1", name: "検査" },
  { code: "2", name: "健診" },
  { code: "3", name: "特定健診" },
];
/*
END
課題・障害番号: 旧：残課題一覧-49
*/

/*
課題・障害番号: KOSHO-173
対応日: 2026/03/30
担当者: 檜垣
修正概要: 一覧の空欄表示に用いる全角ダッシュを定数化
*/
export const LIST_CELL_EMPTY_DISPLAY = "ー";
/*
END
課題・障害番号: KOSHO-173
*/

/*
課題・障害番号: IH-BUG-406
対応日: 2026/04/14
担当者: 檜垣
修正概要: 仮登録段階の登録日表示はハイフンで統一
*/
export const PROVISIONAL_REGISTRATION_DISPLAY = "ー";
/*
END
課題・障害番号: IH-BUG-406
*/

/*
課題・障害番号: IH-BUG-404
対応日: 2026/04/20
担当者: 檜垣
修正概要: 管理者初回ログインの同意画面スキップ判定用クエリを定数化
*/
export const ADMIN_INITIAL_LOGIN_SKIP_AGREEMENT_QUERY = {
  KEY: "token",
  VALUE: "jBNteaw82gdasowe",
};
/*
END
課題・障害番号: IH-BUG-404
*/

// 認証コード -> テーブル種別
export const AUTH_TABLE_TYPE_MAP = {
  1: "company",
  2: "kenpo",
  3: "hospital",
};

// 認証コード -> 識別コード
export const IDENTIFY_CODE_MAP = {
  1: 1, // 企業
  2: 2, // 健保
  3: 3, // 健診機関
};

// お礼表示パターン
export const THANK_DISPLAY_PATTERN = {
  THANKS_DATETIME: "5",
  THANKS_CONFIRM: "6",
};

// お礼区分
export const THANK_TYPE = {
  INPUT_BLOOD_PRESSURE: "10",
  INPUT_WEIGHT: "11",
  INPUT_MEAL: "12",
  INPUT_OTHERS: "20",
  TASK_COMPLETE: "30",
  READ_MESSAGE: "40",
  REPLY_MESSAGE: "41",
  CHECK_HEALTH_RESULT: "50",
  INPUT_HEALTH_RESULT: "51",
  INPUT_INSPECTION_RESULT: "52",
  INPUT_CONSULTATION: "60",
};
// 権限区分
export const AUTH = {
  SYSTEM: 0,
  COMPANY: 1,
  KENPO: 2,
  HOSPITAL: 3,
  USER: 4,
};

/*
課題・障害番号: KOSHO-213
対応日: 2026/04/06
担当者: 檜垣
修正概要: 識別コードごとに編集可能な健診登録者区分を判定する定数を追加
*/
// 健診アップロードの権限区分
export const HEALTH_CHECK_EDITABLE_REGISTER_KIND_BY_IDENTIFY_CD = {
  [String(AUTH.USER)]: "1",
  [String(AUTH.COMPANY)]: "2",
  [String(AUTH.KENPO)]: "3",
};
/*
END
課題・障害番号: KOSHO-213
*/

/*
課題・障害番号: KOSHO-187
対応日: 2026/3/31
担当者: 小林
修正概要: 産業医コメントを権限IDでも入力制御するように修正
*/
// 権限ID
export const ROLE_ID = {
  ADMINISTRATOR: 0,
  MANAGER: 1,
  INDUSTRIAL_PHYSICIAN: 2,
  EMPLOYMENT_MANAGER: 3,
};
/*
END
課題・障害番号: KOSHO-187
*/

// 識別ID先頭文字
export const IDENTIFY_ID_INITIAL_MAP = {
  1: "B",
  2: "K",
  3: "C",
};

// 部門組織
export const MANAGE_TARGET = {
  ORGANIZATION: "1", // 組織
  DEPARTMENT: "2", // 部門
};
/*
課題・障害番号: 品向-17
対応日: 2026/04/03
担当者: 小林
修正概要: 生年月日に設定できる最小日付を設定
*/
// 生年月日(最小日付)
export const MIN_BIRTH = {
  YEAR: 1900,
  MONTH: 0, // 月は0始まり
  DAY: 1,
};
/*
END
課題・障害番号: 品向-17
*/
/*
  課題・障害番号: KOSHO-219
  対応日: 2026/04/03
  担当者: 飛芸
  修正概要: 郵便番号検索APIのエンドポイントを追加
*/
export const ZIPCODE_SEARCH_ENDPOINT = "https://zipcloud.ibsnet.co.jp/api/search";
/*
  END
  課題・障害番号: KOSHO-219
*/

/*
  血糖値追加: 
  対応日: 2026/4/07
  担当者: 越智
  修正概要:血糖値追加（定数をConstantsへ）
*/
export const HEALTH_LIMITS = {
  // 血圧
  /*
  課題・障害番号: 27-KOSHO-9
  対応日: 2026/05/08
  担当者: 檜垣
  修正概要: 生活記録の血圧入力範囲を健診フォーマットの0～350に修正
  */
  BLOOD_PRESSURE: { MIN: 0, MAX: 350 },
  /*
  END
  課題・障害番号: 27-KOSHO-9
  */
  // 脈拍
  PULSE: { MIN: 20, MAX: 250 },
  // 体重
  /*
  課題・障害番号: 27-KOSHO-19
  対応日: 2026/05/08
  担当者: 檜垣
  修正概要: 生活記録の体重入力範囲を健診フォーマットの0～300に修正
  */
  WEIGHT: { MIN: 0, MAX: 300 },
  /*
  END
  課題・障害番号: 27-KOSHO-19
  */
  // 体脂肪率
  /*
  課題・障害番号: 27-KOSHO-20
  対応日: 2026/05/08
  担当者: 檜垣
  修正概要: 生活記録の体脂肪率入力範囲を健診フォーマットの0～300に修正
  */
  BODY_FAT: { MIN: 0, MAX: 300 },
  /*
  END
  課題・障害番号: 27-KOSHO-20
  */
  // 体温
  TEMP: { MIN: 30, MAX: 45 },
  /*
  課題・障害番号: 27-KOSHO-42
  対応日: 2026/05/08
  担当者: 檜垣
  修正概要: 活動量の上限値を99,999kcalで定数化
  */
  ACTIVITY: { MAX: 99999 },
  /*
  END
  課題・障害番号: 27-KOSHO-42
  */
  // 歩数
  STEPS: { MAX: 50000 },
  // 食事
  MEAL: { MAX: 10000 },
  // 血糖値
  GLUCOSE: { MIN: 10, MAX: 600 },
};

/*
課題・障害番号: IH-BUG-469
対応日: 2026/05/20
担当者: 檜垣
修正概要: 血圧の基準値(正常範囲の境界)84/129を定数化。HealthGraph.jsの
         ReferenceAreaのy1/y2と、GraphConfigs.jsのY軸保証ロジックから参照する
         マジックナンバーを集約し、健診基準値の二重持ちによる事故を防止する。
         LOWER=84は拡張期(最低)の正常上限、UPPER=129は収縮期(最高)の正常上限。
         両者で挟まれた帯が「両血圧が正常範囲に収まる」目安帯となる。
*/
export const HEALTH_REFERENCE = {
  BLOOD_PRESSURE: { LOWER: 84, UPPER: 129 },
};
/*
END
課題・障害番号: IH-BUG-469
*/

export const FILE_CONFIG = {
  MAX_FILE_SIZE_MB: 20,
  MAX_ATTACHMENTS: 20,
};
/*
  END
  血糖値追加: 
/*
課題・障害番号: IH-BUG-114
対応日: 2026/04/06
担当者: 檜垣
修正概要: 画像ビューワーの拡大縮小倍率を定数化
*/
export const IMAGE_VIEWER_SCALE = {
  MIN: 1,
  MAX: 4,
  STEP: 0.25,
};
/*
END
課題・障害番号: IH-BUG-114
*/
/*
課題・障害番号: IH-BUG-326、IH-BUG-325、IH-BUG-295
対応日: 2026/04/12
担当者: 藤原
修正概要: 健診結果に実施機関や総合判定が表示されない事象の解消
*/
//健診結果テーブルのカラムと健診項目の紐づけ用
export const KSNSHIN_RESULT_ITEM = {
  finalJudgement: "item_728",
  judgementText: "item_729",
  hospitalCustomName: "item_4",
};

export const KENSHIN_RESULT_DETAIL_ITEM_NUMBER = {
  FINAL_JUDGEMENT: 728,
  JUDGEMENT_TEXT: 729,
  HOSPITAL_CUSTOM_NAME: 4,
};
/*
END
課題・障害番号: IH-BUG-326、IH-BUG-325、IH-BUG-295
*/

/*
  ローディング画面調整
  対応日: 2026/04/19
  担当者: 越智
  修正概要: ローディング画面の最大表示時間(ms)
*/
// 60sの仕様
export const LOADING_SAFETY_TIMEOUT = 60000;
/*
  END
  ローディング画面調整
*/

/*
課題・障害番号: KOSHO-351
対応日: 2026/4/20
担当者: 石川
修正概要:pdfjs-dist のworkerをCDN経由の取得に変更
*/
export const pdfWorker = (version) =>
  `https://cdn.jsdelivr.net/npm/pdfjs-dist@${version}/build/pdf.worker.min.mjs`;

export const VALIDATE = {
  /** 全半カタカナとスペース */
  KATAKANA: {
    PTN: /^[ァ-ヶーｦ-ﾟ\-\s]+$/,
    MSG: "カタカナのみで入力してください",
  },

  /** 携帯(=SMS受診可能)電話番号 */
  MOBILE_TEL: {
    PTN: /^0[6-9]0\d{8}$/,
    MSG: "SMS受信可能な電話番号を、半角数字のみで入力してください",
  },

  /** 電話番号 */
  TEL: {
    PTN: /^0\d{9,10}$/,
    MSG: "半角数字のみで入力してください",
  },

  /** 生年月日 */
  BIRTHDAY: {
    PTN: /^(19|20)\d\d\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12]\d|3[01])$/,
    MSG: "yyyy/MM/dd形式で入力してください",
  },
};
/*
課題・障害番号: KOSHO-324,品向-110、KOSHO-325,品向-111
対応日: 2026/05/05
担当者: 藤原
修正概要: 就業区分、診断区分のチェックが抜けている事象を修正しました。
*/
export const OCCUPATIONAL_KIND = ["有所見", "要受診"];
export const EMPLOYEEMENT_KIND = ["通常勤務", "就業制限", "要休業"];
/*
課題・障害番号: IH-BUG-520
対応日: 2026/05/15
担当者: 藤原
修正概要: 診断区分の項目が誤っていたため修正。
*/
export const DIAGNOSIS_KIND = [
  "異常なし",
  "軽度異常",
  "要検査・生活改善",
  "要精密検査・治療",
  "治療中",
];
/*
END
課題・障害番号: IH-BUG-520
*/
/*
END
課題・障害番号: KOSHO-324,品向-110、KOSHO-325,品向-111
*/
/*
課題・障害番号: 障害番号なし(0508_fujiwara)
対応日: 2026/05/08
担当者: 藤原
修正概要: カラム不足のチェックについて、産業医判定以外のCSV登録の形式を考慮できていなかったため修正。
*/
// 健診結果CAVで特殊な変換が必要なヘッダー項目
export const ALIAS_HEADER_NAME_MAP = {
  氏名: "漢字氏名",
  性別: "男女区分",
};

export const FILE_KIND = {
  HealtchCheckResult: "12", //健診結果
};
/*
END
課題・障害番号: 障害番号なし(0508_fujiwara)
*/
/*
課題・障害番号: タスク要件の見直しに関する修正
対応日: 2026/05/14
担当者: 久留
修正概要: 既にタスクに紐づいているアンケートは削除出来ないよう修正
*/
// アンケートステータス
export const SURVEY_STATUS = {
  DRAFT: "1", // 下書き
  CREATED: "2", // 作成済み
  IN_PROGRESS: "3", // 実施中
  COMPLETED: "4", // 完了
};
/*
END
課題・障害番号: タスク要件の見直しに関する修正
*/
